export const LOAD_USER_PROFILE = 'LOAD_USER_PROFILE'
export const USER_INFO_FETCH_SUCCEEDED = 'USER_INFO_FETCH_SUCCEEDED'
export const USER_INFO_FETCH_FAILED = 'USER_INFO_FETCH_FAILED'
export const USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE'
export const UPDATE_PROFILE_SUCCEEDED = 'UPDATE_PROFILE_SUCCEEDED'
export const UPDATE_PROFILE_FAILED = 'UPDATE_PROFILE_FAILED'
export const USER_UPDATE_PROFILE_TEMPORAL_IMAGE = 'USER_UPDATE_PROFILE_TEMPORAL_IMAGE'
export const EDIT_PROFILE_INFO_FETCH = 'EDIT_PROFILE_INFO_FETCH'
export const EDIT_PROFILE_INFO_SUCCEEDED = 'EDIT_PROFILE_INFO_SUCCEEDED'
export const EDIT_PROFILE_INFO_FAILED = 'EDIT_PROFILE_INFO_FAILED'
export const CONTACT = 'CONTACT'
export const CONTACT_SUCCEEDED = 'CONTACT_SUCCEEDED'
export const CONTACT_FAILED = 'CONTACT_FAILED'
export const SELECT_MEDAL = 'SELECT_MEDAL'
export const SELECT_MISSION = 'SELECT_MISSION'
export const SELECT_MISSION_SUCCEEDED = 'SELECT_MISSION_SUCCEEDED'
export const SELECT_MISSION_FAILED = 'SELECT_MISSION_FAILED'
export const SELECT_ACTIVITY_MEDAL = 'SELECT_ACTIVITY_MEDAL'
export const SELECT_ACTIVITY_MISSION = 'SELECT_ACTIVITY_MISSION'
export const SELECT_ACTIVITY_TITLE = 'SELECT_ACTIVITY_TITLE'
export const EVENT_ALERT_SHOWED = 'EVENT_ALERT_SHOWED'
export const NEW_EVENTS_FETCH_SUCCEEDED = 'NEW_EVENTS_FETCH_SUCCEEDED'
export const NEW_EVENTS_FETCH_FAILED = 'NEW_EVENTS_FETCH_FAILED'

export const eventAlertShowed = () =>
  ({ type: EVENT_ALERT_SHOWED })

export const newEventsFetchSucceeded = ({ lvlup, new_medals, new_titles }) =>
  ({ type: NEW_EVENTS_FETCH_SUCCEEDED, payload: { lvlup, new_medals, new_titles } })

export const newEventsFetchFailed = payload =>
  ({ type: NEW_EVENTS_FETCH_FAILED, payload })

export const loadUserProfile = ({ id }) =>
  ({ type: LOAD_USER_PROFILE, payload: { id } })

export const userInfoFetchFailed = payload =>
  ({ type: USER_INFO_FETCH_FAILED, payload })

export const editProfileInfo = id =>
  ({ type: EDIT_PROFILE_INFO_FETCH, payload: { id } })

export const editProfileSucceeded = data =>
  ({ type: EDIT_PROFILE_INFO_SUCCEEDED, payload: data })

export const editProfileFailed = data =>
  ({ type: EDIT_PROFILE_INFO_FAILED, payload: data })

export const updateProfile = ({ first_name, last_name, id, email, image_url }) =>
  ({ type: USER_UPDATE_PROFILE, payload: { email, first_name, last_name, id, image_url } })

export const updateProfileTemporalImage = ({ temporal_image_url }) =>
  ({ type: USER_UPDATE_PROFILE_TEMPORAL_IMAGE, payload: { temporal_image_url } })

export const updateProfileSucceeded = ({ first_name, last_name, email, image_url }) =>
  ({ type: UPDATE_PROFILE_SUCCEEDED, payload: { first_name, last_name, email, image_url } })

export const updateProfileFailed = ({ first_name, last_name, email, image_url }) =>
  ({ type: UPDATE_PROFILE_FAILED, payload: { first_name, last_name, email, image_url } })

export const selectMedal = ({ id }) =>
  ({ type: SELECT_MEDAL, payload: { id } })

export const selectActivityMedal = ({ medal }) =>
  ({ type: SELECT_ACTIVITY_MEDAL, payload: { medal } })

export const selectActivityMission = ({ mission }) =>
  ({ type: SELECT_ACTIVITY_MISSION, payload: { mission } })

export const selectActivityTitle = ({ title }) =>
  ({ type: SELECT_ACTIVITY_TITLE, payload: { title } })

export const selectMission = ({ id }) =>
  ({ type: SELECT_MISSION, payload: { id } })

export const selectMissionSucceeded = data =>
  ({ type: SELECT_MISSION_SUCCEEDED, payload: data })

export const selectMissionFailed = data =>
  ({ type: SELECT_MISSION_FAILED, payload: data })

export const userInfoFetchSucceeded = ({
  id, first_name, last_name, email, credits, experience,
  level, username, image_url, title, updated_at, missions,
  next_of_next_level_experience, medals, team, next_level_experience,
  titles, current_level_experience }) => ({
    type: USER_INFO_FETCH_SUCCEEDED,
    payload: { id,
      first_name,
      last_name,
      email,
      credits,
      experience,
      level,
      username,
      image_url,
      title: title || { id: null },
      updated_at,
      missions,
      medals,
      team,
      next_level_experience,
      current_level_experience,
      next_of_next_level_experience,
      relative_next_of_next_level_experience: (next_of_next_level_experience - next_level_experience),
      relative_next_level_experience: (next_level_experience - current_level_experience),
      relative_current_experience: Math.max(0, experience - current_level_experience),
      titles,
    },
  })

export const contact = ({ comments, type }) =>
  ({ type: CONTACT, payload: { comments, type } })

export const contactSucceeded = data =>
  ({ type: CONTACT_SUCCEEDED, payload: data })

export const contactFailed = data =>
  ({ type: CONTACT_FAILED, payload: data })




// WEBPACK FOOTER //
// ./src/actions/users.jsx